export const AUTHENTICATE_URL = '/auth/token'
export const AUTHENTICATE_SOCIAL_URL = '/auth/social'
export const REFRESH_TOKEN_URL = `${AUTHENTICATE_URL}/refresh`
export const REVOKE_TOKEN_URL = `${AUTHENTICATE_URL}/revoke`
export const CURRENT_USER_URL = '/user/users/me'
export const ABILITIES_URL = '/authorization/abilities'
